import React, { useEffect, useRef, useState } from 'react'
import AttachmentIcon from "../images/attachmentIcon.svg"
import MenuIcon from '@mui/icons-material/Menu';
import logo1 from "../images/ygLogoMailSignature.png";
import logo2 from "../images/yg_logo.png";
import { OverlayTrigger, Popover, Overlay, Modal, Toast, Offcanvas, Accordion } from 'react-bootstrap'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'
import dayjs from 'dayjs'
import { filesize } from "filesize"
import { emphasize, styled } from '@mui/material/styles'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Chip from '@mui/material/Chip'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import 'react-calendar/dist/Calendar.css'
import { saveAs } from "file-saver"
import DownloadingIcon from '@mui/icons-material/Downloading'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

import questionMarkImage from "../images/peelaBackgroundWalaQuestionMark.png"

import RTE from '../pages/Tickets/RTE'
import { ConfigProvider, Pagination } from "antd";
import CustomSpinner from '../components/CustomSpinner';
import { AnimatePresence, motion } from 'framer-motion';

import MovieIcon from '@mui/icons-material/Movie'
import PermMediaIcon from '@mui/icons-material/PermMedia'
import AudiotrackIcon from '@mui/icons-material/Audiotrack'
import AudioFileIcon from '@mui/icons-material/AudioFile'
import VideoFileIcon from '@mui/icons-material/VideoFile'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

function StudentSupport({ serverURL }) {
  const [addYoutubeVideoShow, setAddYoutubeVideoShow] = useState(false)
  const [videoAdded, setVideoAdded] = useState(false)
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [tags, setTags] = useState(null)


  const [logToUse, setLogToUse] = useState(null);

  const [user, setUser] = useState({})
  const [allTicketHistories, setAllTicketHistories] = useState(null)

  const [pageType, setPageType] = useState("RaiseTicket")
  const urlRef = useRef("")
  const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    const backgroundColor =
      theme.palette.mode === 'light'
        ? theme.palette.grey[100]
        : theme.palette.grey[800];
    return {
      backgroundColor,
      height: theme.spacing(3),
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightRegular,
      '&:hover, &:focus': {
        backgroundColor: emphasize(backgroundColor, 0.06),
      },
      '&:active': {
        boxShadow: theme.shadows[1],
        backgroundColor: emphasize(backgroundColor, 0.12),
      },
    };
  })


  const [showAttachmentPreview, setShowAttachmentPreview] = useState(false)
  const [attachmentToUse, setAttachmentToUse] = useState(null)

  const [milaNahiStudent, setMilaNahiStudent] = useState(false)

  const [showAddNewTicket, setShowAddNewTicket] = useState(false)
  const [assignedToOptions, setAssignedToOptions] = useState(null)

  const [ticketCreated, setTicketCreated] = useState(false)

  const [lastTicket, setLastTicket] = useState(null)

  const [showToast, setShowToast] = useState(false)
  const [toastType, setToastType] = useState(null)
  const [toastTitle, setToastTitle] = useState(null)
  const [toastMessage, setToastMessage] = useState(null)


  const [statusFilter, setStatusFilter] = useState({ "label": "All Unresolved", "value": "Unresolved" })
  const [priorityFilter, setPriorityFilter] = useState(null)
  const [assignedToFilter, setAssignedToFilter] = useState(null)


  const [isDataChanged, setIsDataChanged] = useState({ "status": false, "assignedment": false, "comments": false })


  const dakiyaRef = useRef()
  const [ticketSubjectRef, setticketSubjectRef] = useState("")
  const [registeredId, setRegisteredId] = useState("")
  const [ticketCategory, setTicketCategory] = useState(null)
  const [ticketCategoryRef, setticketCategoryRef] = useState([
    { "label": "General Queries", "value": "General Queries" },
    { "label": "Missing or Incorrect Documents", "value": "Missing or Incorrect Documents" },
    { "label": "APS Related Queries", "value": "APS Related Queries" },
    { "label": "University Shortlisting", "value": "University Shortlisting" },
    { "label": "Application Process Queries", "value": "Application Process Queries" },
    { "label": "Offer Letter / Admission Delay", "value": "Offer Letter / Admission Delay" },
    { "label": "Visa Appointment / Guidance", "value": "Visa Appointment / Guidance" },
    { "label": "Visa Rejection / Document Checklist", "value": "Visa Rejection / Document Checklist" },
    { "label": "Flight or Accommodation Help", "value": "Flight or Accommodation Help" },
    { "label": "Pre-departure Briefing", "value": "Pre-departure Briefing" },
    { "label": "Alumni Support", "value": "Alumni Support" },
    { "label": "Technical Support (Portal / Email / Upload Issues)", "value": "Technical Support (Portal / Email / Upload Issues)" },
    { "label": "Queries Related to Sales Team", "value": "Queries Related to Sales Team" },
    { "label": "Fee Payment or Refund", "value": "Fee Payment or Refund" },
    { "label": "Health Insurance Queries", "value": "Health Insurance Queries" },
    { "label": "German SIM Card / Bank Account Setup", "value": "German SIM Card / Bank Account Setup" },
    { "label": "Forex Card Support", "value": "Forex Card Support" },
    { "label": "Blocked Account Assistance", "value": "Blocked Account Assistance" },
    { "label": "Forex Transfer Assistance", "value": "Forex Transfer Assistance" },
    { "label": "General Insurance Help", "value": "General Insurance Help" },
    { "label": "Study Loan Support", "value": "Study Loan Support" }
  ])
  const [deadlineRef, setdeadlineRef] = useState(dayjs().add(1, "day").format("DD MMM YYYY"))
  const [studentIdRef, setstudentIdRef] = useState("")
  const [attachmentRef, setattachmentRef] = useState([])
  const [ticketStatusRef, setticketStatusRef] = useState({
    "label": "Open",
    "value": "open"
  })
  const [descriptionRef, setdescriptionRef] = useState("")
  const [ticketDepartmentRef, setticketDepartmentRef] = useState(null)
  const [ticketSubDepartmentRef, setticketSubDepartmentRef] = useState(null)
  const [ticketBranchRef, setticketBranchRef] = useState(null)
  const [ticketPriorityRef, setticketPriorityRef] = useState(null)
  const [ticketUserRef, setticketUserRef] = useState(null)

  const [allFilesPreview, setAllFilesPreview] = useState(null)

  const [allDepartments, setAllDepartments] = useState([])
  const [allSubDepartments, setAllSubDepartments] = useState([])

  const [departmentOptions, setdepartmentOptions] = useState(null)
  const [subDepartmentOptions, setSubDepartmentOptions] = useState(null)
  const [ticketOptions, setTicketOptions] = useState(null)

  const [showHelpDialogue, setShowHelpDialogue] = useState(false)

  const [allAutomationRules, setAllAutomationRules] = useState(null)
  const [allAutomationRulesReady, setAllAutomationRulesReady] = useState(false)

  const [allTicketsFromEmail, setAllTicketsFromEmail] = useState(null)

  const [ticketStatus, setTicketStatus] = useState(null)

  const [statusChanger, setStatusChanger] = useState(false)
  const [ticketToUse, setTicketToUse] = useState(null)

  const [assgnedTo, setAssgnedTo] = useState(null)


  const [showLogs, setShowLogs] = useState(false)

  const [statusChanged, setStatusChanged] = useState(false)

  const [ticketStatusOptions, setTicketStatusOptions] = useState(null)

  const [userOptions, setUserOptions] = useState([])

  const [allTicket, setAllTicket] = useState([])

  const [loadingNewEmails, setLoadingNewEmails] = useState(false)

  const [showSideOverlay, setShowSideOverlay] = useState(false)

  const [editorContent, setEditorContent] = useState(null)
  const [logDescEditorContent, setLogDescEditorContent] = useState(null)

  const [entriesLimit, setEntriesLimit] = useState(100)
  const [skipEntries, setSkipEntries] = useState(0)
  const [totalEntriesCount, setTotalEntriesCount] = useState(0)

  const [globalEmail, setGlobalEmail] = useState(null)
  const [globalName, setGlobalName] = useState(null)


  const getAllDepartments = async () => {
    const getDisticsDepartment = await axios.post(serverURL + "/forms/getAnimals")
    if (getDisticsDepartment.status === 200) {
      // console.log(getDisticsDepartment.data)
      setAllDepartments(getDisticsDepartment.data.departments)
      setAllSubDepartments(getDisticsDepartment.data.subDepartments)

      let departmentListings = getDisticsDepartment.data.departments.map((depart, key) => {
        return { "label": depart, "value": depart }
      })
      // console.log(departmentListings)

      setdepartmentOptions(departmentListings)

      let subDepartmentListings = getDisticsDepartment.data.subDepartments.map((subDep, key) => {
        return { "label": subDep.subDepartmnet, "value": subDep.subDepartmnet, "department": subDep.department }
      })

      // console.log(subDepartmentListings)

      setSubDepartmentOptions(subDepartmentListings)


      let userListings = []

      getDisticsDepartment.data.users.map((userData, key) => {
        return userListings.push({ "label": userData.submittedData["Employee Name"], "value": userData.submittedData["Official Mail Id"], "department": userData.submittedData["Process / Department"], "subDepartment": userData.submittedData["Sub Department"], "otherData": userData.submittedData })
      })

      // console.log(userListings)



      setUserOptions(userListings)

      setAssignedToOptions(userListings)


    } else {
      console.log(getDisticsDepartment.data)
    }
  }

  const convertToBase64 = (file) => {
    console.log(file)

    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  }

  const getAllAutomationRules = async () => {
    let automationRules = await axios.post(serverURL + "/tar/getAllRules")
    if (automationRules.status === 200) {
      setAllAutomationRules(automationRules.data)
      setAllAutomationRulesReady(true)
    } else {
      setAllAutomationRulesReady(true)
    }
  }

  const updateSyncedFromEmailAccountMessages = async (ticket, automationRules) => {

    let finalStatus = { "label": "open", "value": "open" }
    let finalPriority = { "label": "Low", "value": "Low" }
    let finalAssignment = { "value": "Not Assigned", "label": "Not Assigned", "otherData": { "Reporting Manager's Email ID": "Not Assigned" } }

    let fromEmailToUse = ticket.createdBy.email

    const findStudentInStudentMaster = await axios.post(serverURL + "/studentMaster/searchStudentByEmail", { email: fromEmailToUse })

    if (automationRules.length > 0 && findStudentInStudentMaster.status === 200) {
      // console.log(findStudentInStudentMaster.data.LocCode, fromEmailToUse)
      let changed = false
      for (let rule of automationRules) {

        if (rule.conditionLogic === "AND") {
          let result = rule.conditions.every((condition) => {
            if (condition.type === "tickets") {
              if (condition.rule === "created-by") {
                if (condition.logic === "contains") {
                  if (fromEmailToUse.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!fromEmailToUse.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (fromEmailToUse === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return fromEmailToUse.includes(val) })) {
                    return true
                  } else {
                    return false
                  }

                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return fromEmailToUse.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }

              } else if (condition.rule === "raised-to") {
                // concerns regarding that
              } else if (condition.rule === "subject") {
                if (condition.logic === "contains") {
                  if (ticket.subject.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!ticket.subject.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (ticket.subject === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return ticket.subject.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return ticket.subject.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }
              } else {
                return false
              }
            } else if (condition.type === "students") {
              if (condition.rule === "intake") {
                if (condition.logic === "contains") {
                  if (findStudentInStudentMaster.data.intakecode?.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!findStudentInStudentMaster.data.intakecode?.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (findStudentInStudentMaster.data.intakecode === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.intakecode?.includes(val) })) {
                    return true
                  } else {
                    return false
                  }

                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.intakecode?.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }
              } else if (condition.rule === "branch") {
                if (condition.logic === "contains") {
                  if (findStudentInStudentMaster.data.LocCode?.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!findStudentInStudentMaster.data.LocCode?.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (findStudentInStudentMaster.data.LocCode === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.LocCode?.includes(val) })) {
                    return true
                  } else {
                    return false
                  }

                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.LocCode?.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }
              }
              else if (condition.rule === "student-email-id") {
                if (condition.logic === "contains") {
                  if (fromEmailToUse.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!fromEmailToUse.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (fromEmailToUse === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return fromEmailToUse.includes(val) })) {
                    return true
                  } else {
                    return false
                  }

                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return fromEmailToUse.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }
              }
              else if (condition.rule === "student-yg-id") {
                if (condition.logic === "contains") {
                  if (fromEmailToUse.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!fromEmailToUse.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (fromEmailToUse === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return fromEmailToUse.includes(val) })) {
                    return true
                  } else {
                    return false
                  }

                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return fromEmailToUse.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }
              }
              else {
                return false
              }
            } else if (condition.type === "yg-mail") {
              if (condition.rule === "intake") {
                if (condition.logic === "contains") {
                  if (findStudentInStudentMaster.data.intakecode?.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!findStudentInStudentMaster.data.intakecode?.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (findStudentInStudentMaster.data.intakecode === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.intakecode?.includes(val) })) {
                    return true
                  } else {
                    return false
                  }

                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.intakecode?.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }
              } else if (condition.rule === "branch") {
                if (condition.logic === "contains") {
                  if (findStudentInStudentMaster.data.LocCode?.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!findStudentInStudentMaster.data.LocCode?.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (findStudentInStudentMaster.data.LocCode === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.LocCode?.includes(val) })) {
                    return true
                  } else {
                    return false
                  }

                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.LocCode?.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }
              } else if (condition.rule === "student-yg-id") {
                if (condition.logic === "contains") {
                  if (fromEmailToUse.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!fromEmailToUse.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (fromEmailToUse === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return fromEmailToUse.includes(val) })) {
                    return true
                  } else {
                    return false
                  }

                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return fromEmailToUse.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }
              }
              else if (condition.rule === "subject") {
                if (condition.logic === "contains") {
                  if (ticket.subject.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!ticket.subject.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (ticket.subject === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return ticket.subject.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return ticket.subject.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }
              }
              else {
                return false
              }
            } else {
              return false
            }
          })

          if (result) {
            changed = true
          }
        } else {
          let result = rule.conditions.some((condition) => {
            if (condition.type === "tickets") {
              if (condition.rule === "created-by") {
                if (condition.logic === "contains") {
                  if (fromEmailToUse.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!fromEmailToUse.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (fromEmailToUse === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return fromEmailToUse.includes(val) })) {
                    return true
                  } else {
                    return false
                  }

                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return fromEmailToUse.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }

              } else if (condition.rule === "raised-by") {
                // concerns regarding that
              } else if (condition.rule === "subject") {
                if (condition.logic === "contains") {
                  if (ticket.subject.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!ticket.subject.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (ticket.subject === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return ticket.subject.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return ticket.subject.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }
              } else {
                return false
              }
            } else if (condition.type === "students") {
              if (condition.rule === "intake") {
                if (condition.logic === "contains") {
                  if (findStudentInStudentMaster.data.intakecode?.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!findStudentInStudentMaster.data.intakecode?.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (findStudentInStudentMaster.data.intakecode === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.intakecode?.includes(val) })) {
                    return true
                  } else {
                    return false
                  }

                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.intakecode?.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }
              } else if (condition.rule === "branch") {
                if (condition.logic === "contains") {
                  if (findStudentInStudentMaster.data.LocCode?.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!findStudentInStudentMaster.data.LocCode?.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (findStudentInStudentMaster.data.LocCode === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.LocCode?.includes(val) })) {
                    return true
                  } else {
                    return false
                  }

                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.LocCode?.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }
              }
              else if (condition.rule === "student-email-id") {
                if (condition.logic === "contains") {
                  if (fromEmailToUse.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!fromEmailToUse.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (fromEmailToUse === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return fromEmailToUse.includes(val) })) {
                    return true
                  } else {
                    return false
                  }

                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return fromEmailToUse.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }
              }
              else if (condition.rule === "student-yg-id") {
                if (condition.logic === "contains") {
                  if (fromEmailToUse.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!fromEmailToUse.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (fromEmailToUse === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return fromEmailToUse.includes(val) })) {
                    return true
                  } else {
                    return false
                  }

                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return fromEmailToUse.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }
              }
              else {
                return false
              }
            } else if (condition.type === "yg-mail") {
              if (condition.rule === "intake") {

              } else if (condition.rule === "branch") {

              } else if (condition.rule === "student-yg-id") {
                if (condition.logic === "contains") {
                  if (fromEmailToUse.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!fromEmailToUse.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (fromEmailToUse === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return fromEmailToUse.includes(val) })) {
                    return true
                  } else {
                    return false
                  }

                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return fromEmailToUse.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }
              }
              else if (condition.rule === "subject") {
                if (condition.logic === "contains") {
                  if (ticket.subject.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-contains") {
                  if (!ticket.subject.includes(condition.value)) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "exact-match") {
                  if (ticket.subject === condition.value) {
                    return true
                  } else {
                    return false
                  }
                }
                else if (condition.logic === "not-in") {
                  if (!condition.value.split(",").some((val) => { return ticket.subject.includes(val) })) {
                    return true
                  } else {
                    return false
                  }

                }
                else if (condition.logic === "in") {
                  if (condition.value.split(",").some((val) => { return ticket.subject.includes(val) })) {
                    return true
                  } else {
                    return false
                  }
                }
                else {
                  return false
                }
              }
              else {
                return false
              }
            } else {
              return false
            }
          })

          if (result) {
            changed = true
          }
        }

      }

      if (changed) {

        for (let rule of automationRules) {
          rule.actions.map((action, key) => {
            Object.keys(action).map((keyName, key) => {

              // console.log(action[keyName])

              if (keyName === "ticket-status") {
                finalStatus = { "label": action[keyName], "value": action[keyName] }
              }
              else if (keyName === "ticket-assigned-to") {
                finalAssignment = { "value": action[keyName], "label": action[keyName], "otherData": { "Reporting Manager's Email ID": "Not Assigned" } }
              }
              else if (keyName === "ticket-priority-as") {
                finalPriority = { "label": action[keyName], "value": action[keyName] }
              }
              else {

              }
            })
          })
        }

      }
    }

    let finalDepartment = ""
    let finalSubDepartment = ""
    let reportingManager = ""

    let finalEmailFormatToUse = ""
    if (finalAssignment.value.includes("<")) {
      finalEmailFormatToUse = finalAssignment.value.split("<")[1].split(">")[0].replaceAll('"', '').replaceAll("'", "")
    } else {
      finalEmailFormatToUse = finalAssignment.value
    }

    const searchPersonInFormDataByEmail = await axios.post(serverURL + "/forms/searchPersonInFormDataByEmail", { "email": finalEmailFormatToUse })

    if (searchPersonInFormDataByEmail.status === 200) {
      // console.log(finalEmailFormatToUse)

      finalDepartment = searchPersonInFormDataByEmail.data.submittedData["Process / Department"]
      finalSubDepartment = searchPersonInFormDataByEmail.data.submittedData["Sub Department"]
      reportingManager = searchPersonInFormDataByEmail.data.submittedData["Reporting Manager's Email ID"]
    }

    let updatedfinalAssignment = { "value": finalEmailFormatToUse, "label": finalEmailFormatToUse, "otherData": { "Reporting Manager's Email ID": reportingManager } }

    const query = {
      "uid": ticket.uid,
      "ticketCategory": ticket.ticketCategory,
      "ticketNumber": ticket.ticketNumber,
      "status": finalStatus,
      "subject": ticket.subject,
      "department": { "value": finalDepartment, "label": finalDepartment },
      "subDepartment": { "value": finalSubDepartment, "label": finalSubDepartment },
      "createdBy": ticket.createdBy,
      "raisedTo": updatedfinalAssignment,
      "description": ticket.description,
      "attachments": ticket.attachments,
      "priority": finalPriority,
      "studentId": findStudentInStudentMaster.data.Stdid,
      "assignedBranch": ticket.assignedBranch,
      "deadline": ticket.deadline,
      "overdue": ticket.overdue,
      "assignedStatus": ticket.assignedStatus,
      "assignedTo": ticket.assgnedTo,
      "escalationTo": ticket.escalationTo,
      "tags": ticket.tags,
      "logs": ticket.logs
    }

    return query
  }

  const createTicketNow = async (e) => {
    e.preventDefault()

    let attachments = []

    const masterTiccketUID = uuidv4()
    let finalTagsFormat = []

    if (tags) {
      let filteredMentions = tags.filter((person) => { return person.id !== String(user.Email).toLowerCase() && person.id !== String(ticketUserRef?.value).toLowerCase() })

      filteredMentions.map((person, key) => {
        if (finalTagsFormat.includes(JSON.stringify(person))) {
          return
        } else {
          return finalTagsFormat.push(JSON.stringify(person))
        }
      })
    }



    if (attachmentRef.length > 0) {
      console.log("attached")


      for (let counter = 0; counter < attachmentRef.length; counter++) {
        await convertToBase64(attachmentRef[counter]).then((result) => {
          attachments.push({
            "fileData": result,
            "uid": uuidv4(),
            "name": attachmentRef[counter].name,
            "type": attachmentRef[counter].type,
            "size": attachmentRef[counter].size
          })
        }).catch((err) => {
          console.log(err)
        })
      }




      // console.log(attachments)

      const query = {
        "uid": masterTiccketUID,
        "ticketCategory": ticketCategory,
        "ticketNumber": lastTicket,
        "status": ticketStatusRef,
        "subject": ticketSubjectRef,
        "department": ticketDepartmentRef,
        "subDepartment": ticketSubDepartmentRef,
        "createdBy": { "name": user.StdName, "email": user.Email, "uid": user.uid, "reportingManager": null },
        "raisedTo": ticketUserRef ? ticketUserRef : "Not Assigned",
        "description": editorContent,
        "attachments": attachments,
        "priority": ticketPriorityRef,
        "studentId": user.Stdid,
        "assignedBranch": user.LocCode,
        "deadline": deadlineRef,
        "overdue": {},
        "assignedStatus": {},
        "assignedTo": {},
        "escalationTo": {},
        "tags": finalTagsFormat,
        "logs": [{
          "updatedByName": user.StdName,
          "updatedByEmail": user.Email,
          "changed": `${user.StdName} created a new ticket`,
          "description": editorContent,
          "updatedOn": dayjs().valueOf()
        }]
      }


      let finalQuery = updateSyncedFromEmailAccountMessages(query, allAutomationRules)

      const createNewTicket = await axios.post(serverURL + "/tickets/create", finalQuery)
      if (createNewTicket.status === 200) {
        // console.log(createNewTicket.data)
        e.target.reset()

        // ############################### Send Notifications To Tagged Person ############################################### 
        console.log(finalTagsFormat)

        const sendTaggedEmailsToMentionedPeople = await axios.post(serverURL + "/tickets/sendMentionedEmails", { "memebers": finalTagsFormat, "ticketNumber": lastTicket, "admin": { "id": user.Email, "name": user.StdName } })

        if (sendTaggedEmailsToMentionedPeople.status === 200) {
          console.log(sendTaggedEmailsToMentionedPeople.data)
        } else {
          console.log(sendTaggedEmailsToMentionedPeople.data)
        }


        setTags(null)
        // ############################### End Notifications To Tagged Person ###############################################
        setAllTicket([createNewTicket.data, ...allTicket])


        userDhundho(registeredId)

        setLastTicket(lastTicket + 1)
        setTicketCategory(null)

        // setticketCategoryRef(null)
        setticketSubjectRef("")
        setticketDepartmentRef(null)
        setticketSubDepartmentRef(null)
        setticketUserRef(null)
        setdescriptionRef("")
        setattachmentRef([])
        setticketPriorityRef(null)
        setstudentIdRef("")
        setticketBranchRef(null)

        setdeadlineRef(dayjs().add(1, "day").format("DD MMM YYYY"))

        setShowAddNewTicket(false)
        setEditorContent(null)
        setLogDescEditorContent(null)

        setShowToast(true)
        setToastType("success")
        setToastTitle("Success")
        setToastMessage("Ticket Created Successfully!")

      } else {
        console.log(createNewTicket.data)
        setShowToast(true)
        setToastType("error")
        setToastTitle("Error")
        setToastMessage(createNewTicket.data)
      }

    } else {

      const query = {
        "uid": masterTiccketUID,
        "ticketCategory": ticketCategory,
        "ticketNumber": lastTicket,
        "status": ticketStatusRef,
        "subject": ticketSubjectRef,
        "department": ticketDepartmentRef,
        "subDepartment": ticketSubDepartmentRef,
        "createdBy": { "name": user.StdName, "email": user.Email, "uid": user.uid },
        "raisedTo": ticketUserRef ? ticketUserRef : "Not Assigned",
        "description": editorContent,
        "attachments": null,
        "priority": ticketPriorityRef,
        "studentId": user.Stdid,
        "assignedBranch": user.LocCode,
        "deadline": deadlineRef,
        "overdue": {},
        "assignedStatus": {},
        "assignedTo": {},
        "escalationTo": {},
        "tags": finalTagsFormat,
        "logs": [{
          "updatedByName": user.StdName,
          "updatedByEmail": user.Email,
          "changed": `${user.StdName} created a new ticket`,
          "updatedOn": dayjs().valueOf(),
        }]
      }
      // console.log(query)

      let finalQuery = await updateSyncedFromEmailAccountMessages(query, allAutomationRules)

      console.log(finalQuery)

      const createNewTicket = await axios.post(serverURL + "/tickets/create", finalQuery)
      if (createNewTicket.status === 200) {
        // console.log(createNewTicket.data)
        e.target.reset()

        // ############################### Send Notifications To Tagged Person ############################################### 

        console.log(finalTagsFormat)

        const sendTaggedEmailsToMentionedPeople = await axios.post(serverURL + "/tickets/sendMentionedEmails", { "members": finalTagsFormat, "ticketNumber": lastTicket, "admin": { "id": user.Email, "name": user.StdName } })

        if (sendTaggedEmailsToMentionedPeople.status === 200) {
          console.log(sendTaggedEmailsToMentionedPeople.data)
        } else {
          console.log(sendTaggedEmailsToMentionedPeople.data)
        }


        setTags(null)
        // ############################### End Notifications To Tagged Person ###############################################

        setAllTicket([createNewTicket.data, ...allTicket])
        userDhundho(registeredId)
        setLastTicket(lastTicket + 1)
        setTicketCategory(null)

        // setticketCategoryRef(null)
        setticketSubjectRef("")
        setticketDepartmentRef(null)
        setticketSubDepartmentRef(null)
        setticketUserRef(null)
        setdescriptionRef("")
        setattachmentRef([])
        setticketPriorityRef(null)
        setstudentIdRef("")
        setticketBranchRef(null)
        setdeadlineRef(dayjs().add(1, "day").format("DD MMM YYYY"))

        setShowAddNewTicket(false)
        setEditorContent(null)
        setLogDescEditorContent(null)


        setShowToast(true)
        setToastType("success")
        setToastTitle("Success")
        setToastMessage("Ticket Created Successfully!")
      } else {
        console.log(createNewTicket.data)
        setShowToast(true)
        setToastType("error")
        setToastTitle("Error")
        setToastMessage(createNewTicket.data)
      }
    }
  }


  const userDhundho = async (userId) => {
    const findStudentByEmail = await axios.post(serverURL + "/studentMaster/searchStudentByEmail", { email: userId })
    if (findStudentByEmail.status === 200) {
      setUser(findStudentByEmail.data)

      const getAllTicketsByEmail = await axios.post(serverURL + "/tickets/getTicketsByEmail", { email: userId })
      if (getAllTicketsByEmail.status === 200) {
        setAllTicketHistories(getAllTicketsByEmail.data)
      } else {
        setAllTicketHistories(null)
      }

      setMilaNahiStudent(false)
    } else {
      setMilaNahiStudent(true)
      setAllTicketHistories(null)
    }
  }

  useEffect(() => {

    let allFiles = []

    for (let counter = 0; counter < attachmentRef.length; counter++) {
      allFiles.push({
        "name": attachmentRef[counter].name,
        "type": attachmentRef[counter].type,
        "size": attachmentRef[counter].size
      })
    }

    console.log(allFiles)

    setAllFilesPreview(allFiles)

  }, [attachmentRef])

  const getAllTickets = async () => {

    setLoadingNewEmails(true)
    const query = {
      "limit": entriesLimit,
      "skip": skipEntries,
      "filters": { "status": statusFilter?.value.toLowerCase(), "priority": priorityFilter?.value, "raisedTo": assignedToFilter?.value }
    }

    console.log(query)

    const getAllTickets = await axios.post(serverURL + "/tickets/getAll", query)
    if (getAllTickets.status === 200) {
      // console.log(getAllTickets.data.lastTicketNumber.ticketNumber)
      setTotalEntriesCount(getAllTickets.data.total)

      if (getAllTickets.data.tickets.length > 0) {
        setLastTicket(getAllTickets.data.lastTicketNumber + 1)
        console.log(getAllTickets.data.lastTicketNumber)
      }

    } else {
      console.log(getAllTickets.data)
      setLastTicket(1)
      setLoadingNewEmails(false)
      setShowToast(true)
      setToastType("error")
      setToastTitle("Error")
      setToastMessage(getAllTickets.data)
    }

  }

  useEffect(() => {
    getAllTickets()
  }, [skipEntries, entriesLimit])


  useEffect(() => {
    if (userOptions.length > 0) {
      getAllTickets()
    }
  }, [statusFilter, priorityFilter, assignedToFilter])


  useEffect(() => {
    if (userOptions.length > 0) {
      console.log(userOptions.find((usrdata) => { return usrdata.value === user.email }))

      setAssignedToFilter(userOptions.find((usrdata) => { return usrdata.value === user.email }))
    }
  }, [userOptions])


  useEffect(() => {
    if (!logToUse) {
      setLogDescEditorContent(null)
      setIsDataChanged({ "status": false, "assignedment": false, "comments": false })
      setEditorContent(null)
      setShowAddNewTicket(false)
    }
  }, [logToUse])

  const changeStatusNow = async (e) => {
    e.preventDefault()

    let subjectOfTitle = ""

    if (isDataChanged.status) {
      subjectOfTitle = `${user.StdName} changed status to ${ticketStatus.label}`
    } else if (isDataChanged.assignedment) {
      subjectOfTitle = `${user.StdName} transfered this ticket to ${assgnedTo.label}`
    } else {
      subjectOfTitle = `${user.StdName} added new note.`
    }


    let finalTagsFormat = []

    if (tags) {
      let filteredMentions = tags.filter((person) => { return person.id !== String(user.email).toLowerCase() && person.id !== String(ticketUserRef?.value).toLowerCase() })

      filteredMentions.map((person, key) => {
        if (finalTagsFormat.includes(JSON.stringify(person))) {
          return
        } else {
          return finalTagsFormat.push(JSON.stringify(person))
        }
      })
    }

    let attachments = []
    if (attachmentRef.length > 0) {
      console.log("attached")

      for (let counter = 0; counter < attachmentRef.length; counter++) {
        await convertToBase64(attachmentRef[counter]).then((result) => {
          attachments.push({
            "fileData": result,
            "uid": uuidv4(),
            "name": attachmentRef[counter].name,
            "type": attachmentRef[counter].type,
            "size": attachmentRef[counter].size
          })
        }).catch((err) => {
          console.log(err)
        })
      }




      console.log(attachments)

      const query = {
        "uid": logToUse.uid,
        "updates": {
          "status": ticketStatus,
          "raisedTo": assgnedTo ? assgnedTo : "Not Assigned",
          "tags": finalTagsFormat,
        },
        "logs": {
          "uid": uuidv4(),
          "updatedByName": user.name,
          "updatedByEmail": user.email,
          "changed": subjectOfTitle,
          "attachments": attachments,
          "description": logDescEditorContent,
          "updatedOn": dayjs().valueOf(),
        }
      }


      console.log(query)

      const updateNow = await axios.post(serverURL + "/tickets/update", query)
      if (updateNow.status === 200) {
        console.log("Done")



        // ############################### Send Notifications To Tagged Person ############################################### 

        console.log(finalTagsFormat)

        const sendTaggedEmailsToMentionedPeople = await axios.post(serverURL + "/tickets/sendMentionedEmails", { "members": finalTagsFormat, "ticketNumber": lastTicket, "admin": { "id": user.email, "name": user.name } })

        if (sendTaggedEmailsToMentionedPeople.status === 200) {
          console.log(sendTaggedEmailsToMentionedPeople.data)
        } else {
          console.log(sendTaggedEmailsToMentionedPeople.data)
        }

        setTags(null)
        // ############################### End Notifications To Tagged Person ###############################################


        setStatusChanged(true)
        setTimeout(() => {
          setStatusChanged(false)
          setStatusChanger(false)
        }, 2000)
        getAllTickets()
        setIsDataChanged({ "status": false, "assignedment": false, "comments": false })

        setLogToUse(null)
        setLogDescEditorContent(null)

        setShowToast(true)
        setToastType("success")
        setToastTitle("Success")
        setToastMessage("Ticket Updated Successfully!")
      } else {
        console.log(updateNow.data)
        setShowToast(true)
        setToastType("error")
        setToastTitle("Error")
        setToastMessage(updateNow.data)
      }
    } else {

      const query = {
        "uid": logToUse.uid,
        "updates": {
          "status": ticketStatus,
          "raisedTo": assgnedTo ? assgnedTo : "Not Assigned",
          "tags": finalTagsFormat,
        },
        "logs": {
          "uid": uuidv4(),
          "updatedByName": user.StdName,
          "updatedByEmail": user.Email,
          "changed": subjectOfTitle,
          "attachments": attachments,
          "description": logDescEditorContent,
          "updatedOn": dayjs().valueOf(),
        }
      }


      console.log(query)

      const updateNow = await axios.post(serverURL + "/tickets/update", query)
      if (updateNow.status === 200) {
        console.log("Done")



        // ############################### Send Notifications To Tagged Person ############################################### 

        console.log(finalTagsFormat)

        const sendTaggedEmailsToMentionedPeople = await axios.post(serverURL + "/tickets/sendMentionedEmails", { "members": finalTagsFormat, "ticketNumber": lastTicket, "admin": { "id": user.email, "name": user.name } })

        if (sendTaggedEmailsToMentionedPeople.status === 200) {
          console.log(sendTaggedEmailsToMentionedPeople.data)
        } else {
          console.log(sendTaggedEmailsToMentionedPeople.data)
        }

        setTags(null)
        // ############################### End Notifications To Tagged Person ###############################################


        setStatusChanged(true)
        setTimeout(() => {
          setStatusChanged(false)
          setStatusChanger(false)
        }, 2000)
        getAllTickets()
        setLogToUse(null)
        setLogDescEditorContent(null)
        setShowToast(true)
        setToastType("success")
        setToastTitle("Success")
        setToastMessage("Ticket Updated Successfully!")
        setIsDataChanged({ "status": false, "assignedment": false, "comments": false })
      } else {
        console.log(updateNow.data)

        setShowToast(true)
        setToastType("error")
        setToastTitle("Error")
        setToastMessage(updateNow.data)
      }
    }
  }

  const getCookies = async () => {
    const getNow = await axios.get(serverURL + "/referal/getCookieUser", { withCredentials: true })
    if (getNow.status === 200) {
      if (getNow.data.user) {
        setGlobalEmail(getNow.data.user)
        setGlobalName(getNow.data.name)

        setRegisteredId(getNow.data.user)
        userDhundho(getNow.data.user)
      }
      console.log(getNow.data)
    } else {
      console.log(getNow.data)
    }
  }


  const showAttachmentPreviewNow = async (refId, docId) => {
    setShowAttachmentPreview(true);

    const getAttachedFile = await axios.post(serverURL + "/attachments/get", { "refId": refId, "docId": docId })

    if (getAttachedFile.status === 200) {
      // console.log(getAttachedFile.data)
      setAttachmentToUse(getAttachedFile.data);
    } else {
      console.log(getAttachedFile.data)
    }


  }

  useEffect(() => {
    getAllDepartments()
    getAllAutomationRules()
    getCookies()
  }, [])

  return (
    <>
      <div className="vh-100 d-flex flex-column p-3">
        <div className="headerUserDetails py-1 mb-3 border-0 d-flex justify-content-between align-items-center">
          <a href="https://yesgermany.com" target='_Blank'>
            <img src={logo1} alt="Yes Germany" className='w-100' style={{ maxWidth: "150px" }} />
          </a>
          <span className='display-6 fw-bold'>Student Support</span>
          <span className='px-3'>
            <img src={questionMarkImage} alt="" style={{ height: "40px", aspectRatio: "1", cursor: "pointer", filter: "drop-shadow(0 4px 4px rgba(0,0,0,0.5))" }} onClick={() => { setShowHelpDialogue(!showHelpDialogue) }} />
          </span>
        </div>
        <div className='d-flex gap-2 justify-content-between align-items-streach px-3 py-1 shadow-sm w-100'>

        </div>

        <div className={`w-100 h-100 overflow-auto d-flex gap-2 p-3`}>
          <div className={`w-100 h-100 overflow-auto d-flex flex-row justify-content-start align-items-start gap-3`}>
            {
              logToUse ?
                <form onSubmit={(e) => { changeStatusNow(e) }} action="" className='w-100 h-100 d-flex gap-1'>
                  <div className='w-100 h-100 p-3 shadow-sm border rounded-4 overflow-auto cardsTransparent '>
                    <div className='d-flex flex-column gap-2 h-100 w-100 overflow-auto' >
                      <div className='d-flex gap-2 justify-content-between w-100 sticky-top p-2 rounded-3' style={{ background: "#ffce00" }}>
                        <span className='fw-bold'>{logToUse.subject}</span>
                        <div className='d-flex gap-2'>
                          <span className='fw-bold'>#YG{String(logToUse.ticketNumber).padStart(6, "0")}</span>
                          {
                            logToUse.status?.value === "open" ?
                              <button className='alert alert-secondary p-0 px-2 m-0 w-100 rounded-4 text-capitalize'>
                                {logToUse.status.value}
                              </button>
                              :
                              logToUse.status?.value === "in-process" ?
                                <button className='alert alert-info p-0 px-2 m-0 w-100 rounded-4 text-capitalize'>
                                  {logToUse.status.value}
                                </button>
                                :
                                logToUse.status?.value === "closed" ?
                                  <button className='alert alert-success p-0 px-2 m-0 w-100 rounded-4 text-capitalize'>
                                    {logToUse.status.value}
                                  </button>
                                  :
                                  logToUse.status?.value === "reopen" ?
                                    <button className='alert alert-warning p-0 px-2 m-0 w-100 rounded-4 text-capitalize'>
                                      {logToUse.status.value}
                                    </button>
                                    :
                                    <button className='alert alert-danger p-0 px-2 m-0 w-100 rounded-4 text-capitalize'>
                                      {logToUse.status.value}
                                    </button>
                          }
                        </div>
                      </div>
                      <div className='d-flex flex-column gap-1 overflow-auto'>
                        {
                          logToUse?.logs.sort((a, b) => b.updatedOn - a.updatedOn).map((log, key) => {
                            return (
                              <div key={key} className={`alert alert-light shadow-sm rounded-3 px-2 py-2 w-100`}>
                                <div className='d-flex justify-content-between w-100'>
                                  <div className='d-flex align-items-center gap-1'>
                                    <img src={`https://placehold.co/40x40/000000/fff?text=${log.updatedByName?.split(" ").map((word, key) => { return word[0] }).join("")}`} alt="" style={{ height: "30px" }} className='rounded-circle border' />
                                    <span className='text-dark fs-6 fw-bold'>{log.changed}</span>
                                  </div>
                                  <span className='text-muted'>{dayjs(log.updatedOn).format("DD MMMM YYYY h:mma")}</span>
                                </div>
                                <div className='d-flex flex-column'>
                                  <RTE
                                    addYoutubeVideoShow={addYoutubeVideoShow}
                                    setAddYoutubeVideoShow={setAddYoutubeVideoShow}
                                    urlRef={urlRef}
                                    videoAdded={videoAdded}
                                    editorContent={log.description}
                                    setEditorContent={setEditorContent}
                                    isEditable={false}
                                    setattachmentRef={setattachmentRef}
                                    isDataChanged={isDataChanged}
                                    setIsDataChanged={setIsDataChanged}
                                    setTags={setTags}
                                  />
                                  <div className='d-flex flex-wrap align-items-center gap-1'>
                                    {
                                      log.attachments?.files?.length > 0 ?
                                        log.attachments?.files.map((file, key) => {
                                          return (
                                            <span className="d-flex gap-1 align-items-center px-1 pt-2" style={{ cursor: "pointer" }} onClick={() => { showAttachmentPreviewNow(log.attachments.refId, file.uid); }}>
                                              {
                                                file.type?.includes("video") ?
                                                  <MovieIcon />
                                                  :
                                                  file?.type?.includes("image") ?
                                                    <PermMediaIcon />
                                                    :
                                                    file?.type?.includes("audio") ?
                                                      <AudiotrackIcon />
                                                      :
                                                      file?.type?.includes("audio") ?
                                                        <AudioFileIcon />
                                                        :
                                                        file?.type?.includes("video") ?
                                                          <VideoFileIcon />
                                                          :
                                                          file?.type?.includes("pdf") ?
                                                            <PictureAsPdfIcon />
                                                            :
                                                            ""
                                              }
                                              <p className='text-truncate w-100 m-0' title={file.name}>{file.name}</p>
                                            </span>
                                          )
                                        })
                                        :
                                        ""
                                    }
                                  </div>
                                </div>
                              </div>
                            )
                          })
                        }
                      </div>
                      {
                        logToUse.status?.label !== 'Closed' &&
                        <div className='bg-light d-flex flex-column p-3 rounded-4'>
                          <RTE
                            addYoutubeVideoShow={addYoutubeVideoShow}
                            setAddYoutubeVideoShow={setAddYoutubeVideoShow}
                            urlRef={urlRef}
                            videoAdded={videoAdded}
                            editorContent={logDescEditorContent}
                            setEditorContent={setLogDescEditorContent}
                            isEditable={true}
                            setattachmentRef={setattachmentRef}
                            isDataChanged={isDataChanged}
                            setIsDataChanged={setIsDataChanged}
                            setTags={setTags}
                          />
                        </div>
                      }

                      <button type='submit' className='btn btn-md btn-dark w-100 rounded-2' disabled={(isDataChanged.status || isDataChanged.assignedment || isDataChanged.comments) ? false : true}>Update</button>

                      {
                        statusChanged ?
                          <div className='alert alert-success p-1 m-0 w-100 text-center'>
                            Updated Successfully!
                          </div>
                          :
                          ""
                      }
                    </div>
                  </div>
                </form>
                :
                <motion.div
                  initial={{ opacity: "0" }}
                  animate={{ opacity: "1" }}
                  exit={{ opacity: "0" }}
                  transition={{ delay: 0, duration: .6 }}
                  className='rounded-3 border d-flex flex-column cardsTransparent'
                  style={{ width: pageType === "RaiseTicket" ? "70%" : "30%", transitionDuration: ".6s" }}>
                  <p className='w-100 fs-5 text-start m-0 py-3 sticky-top d-flex align-items-center justify-content-between'>
                    <span>Submit Your Query</span>
                    <button className='btn btn-md btn-warning rounded-circle shadow-sm w-100 p-0' style={{ maxWidth: "30px", aspectRatio: "1" }} onClick={() => {
                      if (pageType === "TrackTicket") {
                        setPageType("RaiseTicket")
                      } else {
                        setPageType("TrackTicket")
                      }
                    }}>
                      {
                        pageType !== "TrackTicket" ?
                          <i className='fa fa-arrow-left'></i>
                          :
                          <i className='fa fa-arrow-right'></i>
                      }
                    </button>
                  </p>

                  <form action="" onSubmit={(e) => { createTicketNow(e) }} className={`d-flex flex-column gap-3 px-3 py-4 bg-light  rounded-4 shadow-sm border`} ref={dakiyaRef}>
                    <div className='d-flex flex-wrap gap-3 justify-content-around align-items-start'>
                      <TextField
                        id="outlined-basic"
                        required
                        type='email'
                        className='w-100'
                        size='small'
                        label="Registered Email Id"
                        variant="outlined"
                        value={registeredId}
                        onInput={(e) => { setRegisteredId(e.target.value); userDhundho(e.target.value); }} />

                      {
                        milaNahiStudent === true ?
                          <div class="alert alert-warning alert-dismissible fade show d-flex align-items-center" role="alert" style={{ maxWidth: "600px", margin: "auto" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2" viewBox="0 0 16 16" role="img" aria-label="Warning:">
                              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.964 0L.165 13.233c-.457.778.091 1.767.982 1.767h13.706c.89 0 1.438-.99.982-1.767L8.982 1.566zm-.982 4.434a.905.905 0 1 1 1.81 0l-.25 4.5a.655.655 0 0 1-1.31 0l-.25-4.5zm.002 6.813a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                            </svg>
                            <div>
                              It looks like the email address you entered isn't registered in our system. Please review the email or continue using your current address.
                            </div>
                          </div>

                          :
                          ""
                      }

                      <TextField
                        id="outlined-basic"
                        required
                        size='small'
                        className='w-100'
                        label="Ticket Subject"
                        variant="outlined"
                        onInput={(e) => { setticketSubjectRef(e.target.value) }} />





                      <Autocomplete
                        disablePortal
                        value={ticketCategory}
                        onChange={(event, newValues) => setTicketCategory(newValues)}
                        options={ticketCategoryRef}
                        getOptionLabel={(option) => {
                          if (!option) return '';
                          if (typeof option === 'string') return option;
                          if (typeof option.label === 'string') return option.label;
                          return '';
                        }}
                        sx={{ width: "100%" }}
                        size='small'
                        renderInput={(params) => <TextField required {...params} label="Ticket Category" />}
                      />
                    </div>

                    {/* <TextField className='w-100' label="Description" variant="outlined" value={descriptionRef} onInput={(e) => { setdescriptionRef(e.target.value) }} /> */}

                    <div className='d-flex flex-column gap-4'>
                      <RTE
                        addYoutubeVideoShow={addYoutubeVideoShow}
                        setAddYoutubeVideoShow={setAddYoutubeVideoShow}
                        urlRef={urlRef}
                        videoAdded={videoAdded}
                        editorContent={editorContent}
                        setEditorContent={setEditorContent}
                        isEditable={true}
                        setattachmentRef={setattachmentRef}
                        isDataChanged={isDataChanged}
                        setIsDataChanged={setIsDataChanged}
                        setTags={setTags}
                      />
                      <div className='d-flex flex-column'>

                        <button type='button' className='btn btn-md rounded-4' style={{ maxWidth: "120px" }}>
                          <label htmlFor='uthaLeImage1' className='m-0'>
                            <img src={AttachmentIcon} alt="" style={{ height: "25px" }} />
                          </label>
                          <input type="file" multiple id="uthaLeImage1" className='form-control w-100 d-none' onInput={(e) => { setattachmentRef(e.target.files) }} />
                        </button>
                        {
                          allFilesPreview ?
                            allFilesPreview.length > 0 ?
                              <div className="alert alert-info p-1" >
                                {
                                  allFilesPreview.map((file, key) => {
                                    return (
                                      <div className='mb-3 px-2 py-1 d-flex  justify-content-start align-items-center gap-2' key={key}>
                                        <button className='btn btn-outline-danger rounded-circle btn-sm fw-bold fs-6 p-0' type='button' style={{ aspectRatio: "1", height: "24px" }} onClick={(e) => {
                                          setAllFilesPreview(allFilesPreview.filter((gotFile) => {
                                            return gotFile.name !== file.name
                                          }))
                                        }}>
                                          <i className='fa fa-times'></i>
                                        </button>
                                        <div>
                                          <p className='m-0'>Name:<span> {file.name}</span></p>
                                          <p className='m-0'>Size:<span> {filesize(file.size, { "standard": "jedec" })}</span></p>
                                        </div>
                                      </div>
                                    )
                                  })
                                }
                              </div>
                              :
                              ""
                            :
                            ""
                        }
                      </div>
                      {
                        ticketCreated ?
                          <div className='alert alert-success p-1 m-0 w-100 text-center'>
                            Ticket Created
                          </div>
                          :
                          ""
                      }
                      <div className='d-flex w-100 justify-content-center'>
                        <button type='submit' className='btn btn-md btn-dark w-100 rounded-3 shadow' style={{ maxWidth: "120px" }}>Create</button>
                      </div>
                    </div>

                  </form>
                </motion.div>

            }


            <motion.div
              initial={{ opacity: "0" }}
              animate={{ opacity: "1" }}
              exit={{ opacity: "0" }}
              transition={{ delay: 0, duration: .6 }}
              style={{ width: pageType === "TrackTicket" ? "70%" : "30%", transitionDuration: ".6s" }}
              className='d-flex flex-column justify-content-start align-items-center gap-3 border cardsTransparent overflow-auto h-100'
            >
              <div className="shadow-sm text-center p-2 w-100 sticky-top rounded-3" style={{ background: "black" }}>
                <span style={{ color: "#ffce00", fontWeight: "600" }}>
                  Track Your Queries
                </span>
              </div>

              <div className='w-100'>
                {
                  allTicketHistories ?
                    allTicketHistories.length > 0 ?
                      allTicketHistories.map((ticket, key) => {
                        return (
                          <div className="alert alert-warning d-flex align-items-start gap-1 flex-column w-100" style={{ cursor: "pointer" }} key={key} onClick={() => {
                            setLogToUse(ticket);
                            setAssgnedTo(ticket.raisedTo);
                            setShowLogs(true);
                            setEditorContent(ticket.description);
                            setTicketStatus(ticket.status);
                            setTicketStatusOptions(
                              ticket.status.label === "Open" ?
                                [
                                  { "label": "Open", "value": "open" },
                                  { "label": "In-Process", "value": "in-process" },
                                  { "label": "Closed", "value": "closed" },
                                ]
                                :
                                ticket.status.label === "In-Process" ?
                                  [
                                    { "label": "In-Process", "value": "in-process" },
                                    { "label": "Closed", "value": "closed" },
                                  ]
                                  :
                                  ticket.status.label === "Re-Open" ?
                                    [
                                      { "label": "Re-Open", "value": "re-open" },
                                      { "label": "Closed", "value": "closed" },
                                    ]
                                    :
                                    ticket.status.label === "Closed" && ticket.createdBy.email === user.email ?
                                      [
                                        { "label": "Re-Open", "value": "re-open" },
                                        { "label": "Closed", "value": "closed" }
                                      ]
                                      :
                                      []
                            )
                          }}>
                            <div className='d-flex gap-2 justify-content-between w-100'>
                              <span className='fw-bold'>{ticket.subject}</span>
                              <div className='d-flex gap-2'>
                                <span className='fw-bold'>#YG{String(ticket.ticketNumber).padStart(6, "0")}</span>
                                {
                                  ticket.status?.value === "open" ?
                                    <button className='alert alert-secondary p-0 px-2 m-0 w-100 rounded-4 text-capitalize'>
                                      {ticket.status.value}
                                    </button>
                                    :
                                    ticket.status?.value === "in-process" ?
                                      <button className='alert alert-info p-0 px-2 m-0 w-100 rounded-4 text-capitalize'>
                                        {ticket.status.value}
                                      </button>
                                      :
                                      ticket.status?.value === "closed" ?
                                        <button className='alert alert-success p-0 px-2 m-0 w-100 rounded-4 text-capitalize'>
                                          {ticket.status.value}
                                        </button>
                                        :
                                        ticket.status?.value === "reopen" ?
                                          <button className='alert alert-warning p-0 px-2 m-0 w-100 rounded-4 text-capitalize'>
                                            {ticket.status.value}
                                          </button>
                                          :
                                          <button className='alert alert-danger p-0 px-2 m-0 w-100 rounded-4 text-capitalize'>
                                            {ticket.status.value}
                                          </button>
                                }
                              </div>
                            </div>
                            <hr className="w-100 m-0 mt-1" />
                            <span>Created: {dayjs(ticket.createdAt).format("dddd, DD MMMM YYYY")}</span>
                            <span>Last Update: {dayjs(ticket.updatedAt).format("dddd, DD MMMM YYYY")}</span>
                          </div>
                        )
                      })
                      :
                      <p className='text-center'>No tickets Found</p>
                    :
                    <p className='text-center'>No tickets Found</p>
                }
              </div>
            </motion.div>
          </div>
        </div>

      </div>

      {/* ############################### Attachment Preview Panel ############################# */}
      <Modal
        show={showAttachmentPreview}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        onHide={() => { setShowAttachmentPreview(false); setAttachmentToUse(null) }}
      >
        <Modal.Header className="py-2" closeButton closeVariant='black'>
          <Modal.Title id="contained-modal-title-vcenter">
            <div className=' d-flex flex-column'>
              <span>
                Attachment Preview
              </span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='d-flex gap-3 flex-column'>
            <div className='d-flex gap-1'>
              <span className='text-nowrap fw-bold'>File Name:</span>
              <span className='text-nowrap text-truncate'>{attachmentToUse?.name}</span>
            </div>
            <div className='d-flex gap-1'>
              <span className='text-nowrap fw-bold'>File Size:</span>
              <span className='text-nowrap text-truncate'>{filesize(attachmentToUse?.size ? attachmentToUse.size : 0, { "standard": "jedec" })}</span>
            </div>
            <div className='d-flex gap-1'>

              <button className='btn btn-sm btn-outline-success d-flex align-items-center gap-1 rounded-pill p-0'>
                <DownloadingIcon style={{ fontSize: "2rem" }} onClick={(e) => { saveAs(attachmentToUse?.fileData, attachmentToUse?.name) }} />
              </button>
            </div>

            <div className='m-0 p-0' style={{ background: 'rgba(66, 61, 61, 0.3)', backdropFilter: "blur(3px)" }}>
              {
                attachmentToUse ?
                  attachmentToUse.type?.includes("image") ?
                    <img src={attachmentToUse.fileData} className='w-100' style={{ aspectRatio: "16/9", objectFit: "contain" }} />
                    :
                    attachmentToUse.type?.includes("video") ?
                      <video src={attachmentToUse.fileData} controls className='w-100' style={{ aspectRatio: "16/9" }}></video>
                      :
                      <i className='fa fa-download'>{attachmentToUse.name}</i>
                  :
                  <SkeletonTheme
                    baseColor="rgb(206, 245, 255)"
                    // highlightColor="#070707a0"
                    direction="ltr"
                    duration={2}
                    customHighlightBackground="linear-gradient(90deg, transparent,rgba(68, 214, 250, 0.63), transparent">
                    <Skeleton count={1} className='w-100 p-0 m-0' style={{ aspectRatio: "16/9" }} />
                  </SkeletonTheme>

              }
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* ############################### Attachment Preview Panel End ############################# */}

      <Modal
        centered
        backdrop="static"
        size='lg'
        show={showHelpDialogue}
        onHide={() => { setShowHelpDialogue(false); }}
      >
        <Modal.Header className='rounded-4 d-flex align-items-start p-0 m-0 gap-0 flex-column-reverse' >
          <div
            style={{
              backgroundColor: "#f9f9f9",
              borderLeft: "5px solid #ffce00",
              padding: "25px",
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.261)",
              fontFamily: "'Segoe UI', Tahoma, sans-serif",
              fontSize: "15px",
              color: "#333"
            }}
          >
            <div className='d-flex gap-1 align-items-start justify-content-between'>

              <h3 style={{ marginTop: 0, fontSize: "20px", color: "#000" }}>
                How to Use the Yes Germany Student&apos;s Support Portal?
              </h3>

              <i className='fa fa-times text-dark fs-4' style={{ cursor: "pointer" }} onClick={() => { setShowHelpDialogue(false) }}></i>

            </div>
            <hr style={{ color: "#333", margin: "25px" }} />

            <div style={{ marginTop: "15px" }}>
              <h4 style={{ margin: "10px 0 5px", color: "#000", fontSize: "16px" }}>
                ✍️ How to Submit a New Ticket:
              </h4>
              <ul style={{ paddingLeft: "20px", margin: 0 }}>
                <li style={{ marginBottom: "8px" }}>
                  Enter your <strong>registered email ID</strong>
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Add a <strong>Title</strong> summarizing your issue
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Select the appropriate <strong>Category</strong> (e.g., Visa, Documents, University)
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Write a clear <strong>Description</strong> explaining your concern
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Click on <strong>"Create"</strong> to submit the ticket
                </li>
              </ul>

              <hr style={{ color: "#333", margin: "25px" }} />

              <h4 style={{ margin: "20px 0 5px", color: "#000", fontSize: "16px" }}>
                🔍 How to Track or Follow Up:
              </h4>
              <ul style={{ paddingLeft: "20px", margin: 0 }}>
                <li style={{ marginBottom: "8px" }}>
                  Enter your <strong>registered email ID</strong> again
                </li>
                <li style={{ marginBottom: "8px" }}>
                  In the <strong>"Track Your Queries"</strong> section, view all your submitted tickets
                </li>
                <li style={{ marginBottom: "8px" }}>
                  Click on any ticket to <strong>view updates</strong> or <strong>add comments</strong>
                </li>
              </ul>
            </div>

            <hr style={{ color: "#333", margin: "25px" }} />

            <div
              style={{
                marginTop: "20px",
                backgroundColor: "#fff7d6",
                padding: "15px 20px",
                borderLeft: "5px solid #ffce00",
                borderRadius: "6px"
              }}
            >
              ⚠️ <strong>Tip:</strong> For faster response and easy tracking, always use the support portal instead of email or WhatsApp.
            </div>
          </div>
        </Modal.Header>
      </Modal>
      <Modal
        centered
        backdrop="static"
        size='md'
        show={addYoutubeVideoShow}
        onHide={() => { setAddYoutubeVideoShow(false); }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Add YouTube Video
          </Modal.Title>
        </Modal.Header>

        <form onSubmit={(e) => {
          e.preventDefault();
          setVideoAdded(urlRef.current.value)
          console.log(urlRef.current.value)
          setAddYoutubeVideoShow(false)
        }}>
          <Modal.Body>
            <input type="url" className='form-control' placeholder="Enter Video URL" required ref={urlRef} />
          </Modal.Body>
          <Modal.Footer>
            <input type="submit" value={"Add Video"} />
          </Modal.Footer>
        </form>
      </Modal>

      {/* ############################### Notification Panel Start ############################# */}
      {
        showToast &&
        <div style={{ position: "fixed", bottom: "5px", right: "5px" }}>
          <Toast
            show={showToast}
            position="bottom-end"
            onClose={() => {
              setShowToast(false)
              setToastType(null)
              setToastTitle(null)
              setToastMessage(null)
            }}
            delay={2000}
            autohide
          // bg={toastType === "error" ? "danger" : toastType === "warning" ? "warning" : toastType === "info" ? "info" : toastType === "success" ? "success" : "success"}
          >
            <Toast.Header>
              <img src="holder.js/20x20?text=%20" className="rounded me-2" alt="" />
              <strong className="me-auto">{toastTitle}</strong>
              <small>Just Now</small>
            </Toast.Header>
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </div>
      }
      {/* ############################### Notification Panel End ############################# */}
    </>
  )
}

export default StudentSupport